import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

import type { FocalPoint } from "@/types"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Anchors `object-cover` crops to the subject of an image instead of
// dead-center. Returns undefined when no focal point is set so the
// browser falls back to its default (center). Values are percentages
// (0–100) stored on the Active Storage blob's metadata.
export function focalPointStyle(
  fp?: FocalPoint | null,
): React.CSSProperties | undefined {
  if (!fp) return undefined
  return { objectPosition: `${fp.x}% ${fp.y}%` }
}
